(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairStudentsInterestAreasController', VirtualFairStudentsInterestAreasController);
        VirtualFairStudentsInterestAreasController.$inject = ['$filter', 'VirtualFairService', 'ExpoService', 'CitiesByExpoService'];
    function VirtualFairStudentsInterestAreasController($filter, VirtualFairService, ExpoService, CitiesByExpoService) {
        var vm = this;

        vm.getInterestAreas     = getInterestAreas;
        vm.getByFilter          = getByFilter;
        vm.clearForm            = clearForm;
        vm.activate             = activate;
        vm.getPercentage        = getPercentage;
        vm.getAllVirtualFair    = getAllVirtualFair;
        vm.getAllPhysicalFair   = getAllPhysicalFair;
        vm.selecEvent           = selecEvent;
        vm.getCitiesByExpo      = getCitiesByExpo;
        
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.interestAreas            = []
        vm.interestAreasSelected    = [];
        vm.virtualFairs             = [];
        vm.virtualFairSelected      = [];
        vm.physicalFairs            = [];
        vm.physicalFairSelected     = [];
        vm.cities                   = [];
        vm.citiesSelected           = [];
        vm.loggedInApp              = false;
        vm.flag                     = false;

        function clearForm () {
            vm.interestAreasSelected = [];
            vm.virtualFairSelected = [];
            vm.physicalFairSelected = [];
            vm.loggedInApp = false;
        }

        function getByFilter () {
            vm.flag = false;
            let query = {};
            query['interest_areas'] = JSON.stringify(vm.interestAreasSelected);
            query['virtual_fairs'] = JSON.stringify(vm.virtualFairSelected);
            query['physical_fairs'] = JSON.stringify(vm.physicalFairSelected);
            query['locations'] = JSON.stringify(vm.citiesSelected);
            query['logged_in_app'] = vm.loggedInApp;
            VirtualFairService.getStudentsInterestAreas(query).then(function(response) {
                vm.flag = true;
                vm.studentsInterestAreas = response.data.areas;
                vm.studentsCountries = response.data.countries;
                vm.studentsAges = response.data.ages;
                vm.studentsPrograms = response.data.programs;
                vm.studentsCountriesInterest = response.data.countries_interest;
                vm.total = response.data.ages[0].total;
            }).catch(function(err) {
            });
        }

        function getCitiesByExpo () {
            vm.query = {};
            vm.query['expos_ids']  = JSON.stringify(vm.physicalFairSelected);
            CitiesByExpoService.getCitiesByExposIds(vm.query).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {

            });
        }

        function getInterestAreas() {
            VirtualFairService.getInterestAreas().then(function(response) {
                vm.interestAreas = response.data;
            }).catch(function(err) {
            });
        }

        function getAllVirtualFair () {
            VirtualFairService.getAll().then(function(response) {
                vm.virtualFairs = response.data;
            }).catch(function(err) {
            });
        }

        function getAllPhysicalFair () {
            ExpoService.getExpos().then(function(response) {
                vm.physicalFairs = response.data;
            }).catch(function(err) {
            });
        }

        function getPercentage(total, total_by_area){

            console.log(parseInt(total), parseInt(total_by_area));
            return ((parseInt(total_by_area) * 100) / parseInt(total)).toFixed(2) + '%';
        }

        function selecEvent(type) {
            if (type == 'virtual') {                
                vm.physicalFairSelected = [];
                vm.citiesSelected = [];
            } else {
                vm.virtualFairSelected = [];
                vm.getCitiesByExpo();
            }
        }

        function activate () {
            vm.getInterestAreas();
            vm.getAllVirtualFair();
            vm.getAllPhysicalFair();
            // vm.getByFilter();
        }

        vm.activate();
    }
})();